import { render, staticRenderFns } from "./JobLaboralFunctionAddEdit.vue?vue&type=template&id=464490a6"
import script from "./JobLaboralFunctionAddEdit.vue?vue&type=script&lang=js"
export * from "./JobLaboralFunctionAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports